const NON_ESSENTIALS = [
  {
    label: "Clothing/Shoes",
    value: "clothing/shoes"
  },
  {
    label: "Personal Care",
    value: "personalcare"
  },
  {
    label: "Travel",
    value: "travel"
  },
  {
    label: "Going Out/Fun",
    value: "goingout/fun"
  }
];

export const NON_ESSENTIALS_LABELS = NON_ESSENTIALS.reduce((prev, next) => {
  prev[next.value] = next.label;

  return prev;
}, {});

export default NON_ESSENTIALS;
